export const userKey = (userId?: string | null) => ["users", userId] as const;
export const businessUsersKey = (businessId?: string | null) =>
  ["users", "business", businessId] as const;
export const userStatsKey = (businessId?: string | null, timeFrame?: string) =>
  ["users", "stats", businessId, timeFrame] as const;
